//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, ConciergeProxy, SagasHelper, LogsProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

import PermisoManager from '../../../Common/Managers/PermisoManager';

// ACTION TYPES
export const GET_SCREEN_DATA_EDITPERMISOS_STARTS = "GET_SCREEN_DATA_EDITPERMISOS_STARTS";
export const SET_USER_FUNCTIONS_EDITPERMISOS = 'SET_USER_FUNCTIONS_EDITPERMISOS';
export const GET_SCREEN_DATA_EDITPERMISOS_SUCCESS = 'GET_SCREEN_DATA_EDITPERMISOS_SUCCESS';
export const RESET_STATE_EDITPERMISOS = "RESET_STATE_EDITPERMISOS";
export const ESCONDER_POPUP_EDITPERMISOS = 'ESCONDER_POPUP_EDITPERMISOS';
export const SELECT_PRODUCTO_EDITPERMISOS = 'SELECT_PRODUCTO_EDITPERMISOS'; 
export const SELECT_CATEGORIA_EDITPERMISOS = 'SELECT_CATEGORIA_EDITPERMISOS';
export const SELECT_PROGRAMA_EDITPERMISOS = 'SELECT_PROGRAMA_EDITPERMISOS';
export const ELIMINAR_FUNCION_EDITPERMISOS = 'ELIMINAR_FUNCION_EDITPERMISOS';
export const AGREGAR_FUNCION_EDITPERMISOS = 'AGREGAR_FUNCION_EDITPERMISOS';
export const ELIMINAR_HISTORIAL_EDITPERMISOS = 'ELIMINAR_HISTORIAL_EDITPERMISOS';
export const SELECCIONAR_HISTORIAL_EDITPERMISOS = 'SELECCIONAR_HISTORIAL_EDITPERMISOS';
export const REDIRECT_OK_EDITPERMISOS = 'REDIRECT_OK_EDITPERMISOS';
export const EDITPERMISOS_FAIL = 'EDITPERMISOS_FAIL'; 

/**
 * Variables globales
 */
let _dispatch, _currentScope, _getState = null;

/**
 * * Obtiene los datos para popular la pantalla.
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch) => {
        _currentScope = currentScope;
        _dispatch = dispatch;
        dispatch({ type: GET_SCREEN_DATA_EDITPERMISOS_STARTS });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenDataCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 * @param {any} currentScope
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_EDITPERMISOS });
    }
}

/**
 * Filtra la categoria en cascada, dependiendo del producto seleccionado.
 * @param {any} id
 */
export function selectProducto(id) {
    LogHelper.In(selectProducto.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_PRODUCTO_EDITPERMISOS, id });
    }
}

/**
 * Filtra el programa en cascada, dependiendo de la categoria seleccionada.
 * @param {any} id
 */
export function selectCategoria(id) {
    LogHelper.In(selectCategoria.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_CATEGORIA_EDITPERMISOS, id });
    }
}

/**
 * Obtiene los permisos, para las funcionalidades en pantalla, dependiendo del filtro de programa seleccionado.
 * @param {any} id
 */
export function selectPrograma(id) {
    LogHelper.In(selectPrograma.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().editarPermisos));
        let localValue = {
            'PRODUCT_ID': state.filter.product,
            'CATEGORY_ID': state.filter.category,
            'PROGRAM_ID': id
        }

        LogHelper.Out(selectPrograma.name, localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        LogHelper.Out(selectPrograma.name, localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get', 
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesCallback(data, id), null, null, "SEGURIDAD");
    }
}

/**
 * Esconde popup de error.
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_EDITPERMISOS });
    }
}

/**
 * Elimina una funcionalidad de un permiso.
 * @param {any} perfilId
 * @param {any} functionId
 */
export function deleteFuncion(perfilId, funcion) {
    LogHelper.In(deleteFuncion.name, perfilId, funcion);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ELIMINAR_FUNCION_EDITPERMISOS, perfilId, funcion });
    }
}

/**
 * Agrega una funcionalidad a un permiso.
 * @param {any} perfilId
 * @param {any} function
 */
export function addFuncion(perfilId, funcion) {
    LogHelper.In(addFuncion.name, perfilId, funcion);
     
    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: AGREGAR_FUNCION_EDITPERMISOS, perfilId, funcion });
    }
}

/**
 * Elimina los cambios realizados sobre un permiso.
 * @param {any} historialId
 */
export function deleteHistorial(historialId) {
    LogHelper.In(deleteHistorial.name, historialId);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ELIMINAR_HISTORIAL_EDITPERMISOS, historialId });
    }
}

/**
 * Selecciona un historial de la grilla
 * @param {any} productoId
 * @param {any} categoriaId
 * @param {any} programaId
 */
export function selectHistorial(productoId, categoriaId, programaId) {
    LogHelper.In(selectHistorial.name, productoId, categoriaId, programaId);

    return (dispatch) => {
        _dispatch = dispatch;

        let localValue = {
            'PRODUCT_ID': productoId,
            'CATEGORY_ID': categoriaId,
            'PROGRAM_ID': programaId
        }

        LogHelper.Out(selectHistorial.name, localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _selectHistorialCallback(data, productoId, categoriaId, programaId), null, null, "SEGURIDAD");
    }
}

/**
 * Impacta las modificaciones en la base de datos.
 */
export function saveChanges() {
    LogHelper.In(saveChanges.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _getState = getState;
        let state = JSON.parse(JSON.stringify(getState().editarPermisos));

        let localValue;
        let createFunctionalities = [];
        let deleteFunctionalities = [];

        state.historial.forEach(function (historial) {
            historial.perfiles.forEach(function (perfil) {
                perfil.functions.forEach(function (funcion) {
                    localValue = {
                        'PERFIL_ID': perfil.Id,
                        'PRODUCTO_ID': historial.producto.Id,
                        'CATEGORIA_ID': historial.categoria.Id,
                        'PROGRAMA_ID': historial.programa.Id,
                        'FUNCION_ID': funcion.Id
                    };

                    if (funcion.Eliminada == true) {
                        deleteFunctionalities.push(localValue);
                    }
                    else if (funcion.Agregada == true) {
                        createFunctionalities.push(localValue);
                    }
                });
            });
        });

        if (deleteFunctionalities.length > 0 || createFunctionalities.length > 0) {
            _dispatch({ type: GET_SCREEN_DATA_EDITPERMISOS_STARTS });

            LogHelper.Out(saveChanges.name, { Functionalities: deleteFunctionalities }, "UpdatePermisoFuncionalidadPuntual",
                _currentScope.ProductCode, "SEGURIDAD");

                if (sessionStorage.getItem('PantallaCambios') == "true") {
                    sessionStorage.removeItem('PantallaCambios');
                }    
            PermisoManager.UpdatePermisoFuncionalidadPuntual(deleteFunctionalities, createFunctionalities, SagasHelper.GetSagasId, ejecutarPorEstado);
        }
    }
}

/**
 * Notifica error en caso que no se hayan encontrado cambios en los datos. 
 */
export function errorSave() {
    LogHelper.In(errorSave.name);

    return (dispatch) => {
        _dispatch = dispatch;        

        _error("No se encontraron cambios");
    }
}

/**
 * Redirecciona luego impactar los cambios.
 */
export function setRedirectOk() {
    LogHelper.In(setRedirectOk.name);

    if (sessionStorage.getItem('PantallaCambios') == "true") {
        sessionStorage.removeItem('PantallaCambios');
    }

    return (dispatch) => {
        _dispatch = dispatch;

        $("#discardChangesModal").modal('toggle');

        _setRedirect();
    }
}

/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Funcion callback de los datos principales para popular la pantalla.
 * @param {any} data
 */
function _loadScreenDataCallback(data) {
    LogHelper.In(_loadScreenDataCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_USER_FUNCTIONS_EDITPERMISOS, functions });

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PRODUCTOS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PRODUCTOS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_CATEGORIAS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CATEGORIAS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PROGRAMAS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROGRAMAS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PERFILES', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFILES', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    Engine1Proxy.Execute(_loadEditarPermisosInitialStateCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion que parsea los datos recibidos del Engine1 para retornarlos a pantalla.
 * @param {any} data
 */
function _loadEditarPermisosInitialStateCallback(data) {
    LogHelper.In(_loadEditarPermisosInitialStateCallback.name, data);

    let result = {
        GET_PRODUCTOS: JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows,
        GET_CATEGORIAS: JSON.parse(data.GET_CATEGORIAS).Recordset0.Rows,
        GET_PROGRAMAS: JSON.parse(data.GET_PROGRAMAS).Recordset0.Rows,
        GET_PERFILES: JSON.parse(data.GET_PERFILES).Recordset0.Rows
    };

    result.GET_PRODUCTOS.unshift({ Id: 0, Descripcion: "Producto..." });
    result.GET_CATEGORIAS.unshift({ Id: 0, Descripcion: "Categoria..." });
    result.GET_PROGRAMAS.unshift({ Id: 0, Descripcion: "Programa..." });

    for (var i = 0; i < result.GET_PERFILES.length; i++) {
        result.GET_PERFILES[i].first = (i === 0);
        result.GET_PERFILES[i].functions = [];
    }

    _dispatch({ type: GET_SCREEN_DATA_EDITPERMISOS_SUCCESS, result });
}

/**
 * Funcion callback de las funcionalidades para los filtros seleccionados.
 * @param {any} data
 * @param {any} id
 */
function _funcionalidadesCallback(data, id) {
    LogHelper.In(_funcionalidadesCallback.name, data, id);

    let result = {
        id: id,
        funciones_perfil: JSON.parse(data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD).Recordset0.Rows,
        funciones_tabla: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    result.funciones_tabla.unshift({ Id: 0, Descripcion: "Todos" });

    _dispatch({ type: SELECT_PROGRAMA_EDITPERMISOS, result });
}

/**
 * Funcion callback del historial de modificacion del permiso seleccionado.
 * @param {any} data
 * @param {any} productoId
 * @param {any} categoriaId
 * @param {any} programaId
 */
function _selectHistorialCallback(data, productoId, categoriaId, programaId) {
    LogHelper.In(_selectHistorialCallback.name, data, productoId, categoriaId, programaId);

    let response = {
        funciones_perfil: JSON.parse(data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD).Recordset0.Rows,
        productoId, categoriaId, programaId
    };

    _dispatch({ type: SELECCIONAR_HISTORIAL_EDITPERMISOS, response });
}

/**
 * Funcion que redirecciona a la pagina de Perfiles y Permisos.
 */
function _setRedirect() {
    LogHelper.In(_setRedirect.name);

    _dispatch({ type: REDIRECT_OK_EDITPERMISOS });
}

/**
 * Funcion que notifica error en la operacion de grabado.
 * @param {any} message
 */
function _error(message) {
    LogHelper.In(_error.name, message);

    _dispatch({ type: EDITPERMISOS_FAIL, message });
}

/**
 * Callback de llamado a Sagas en el alta/edición de usuario
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    let message;

    switch (result.Estado) {
        case 2:
            logsEditarPermisos();
            break;

        case 3:

            _error("Hubo un error al procesar la transacci\u00F3n");

            break;

        case 5:

            _error("Hubo un error al procesar la transacci\u00F3n");

            break;

        default:

            _error("Hubo un error al procesar la transacci\u00F3n");

            break;
    }

    disconectCallback();
}

function logsEditarPermisos() {
    let historial = JSON.parse(JSON.stringify(_getState().editarPermisos.historial));

    let anterior = '';
    let actual = '';

    historial.forEach(function (historia) {

        historia.perfiles.forEach(function (perfil) {

            anterior += ' Producto: ' + historia.producto.Descripcion + ' | Categoria: ' + historia.categoria.Descripcion + ' | Programa: ' + historia.programa.Descripcion + ' | Perfil: ' + perfil.Descripcion + ' | función: ';
            actual += ' Producto: ' + historia.producto.Descripcion + ' | Categoria: ' + historia.categoria.Descripcion + ' | Programa: ' + historia.programa.Descripcion + ' | Perfil: ' + perfil.Descripcion + ' | función: ';

            let funcionAnterior = [];
            let funcionActual = [];

            let funcTocados = [];
            let funcSintocar = [];

            perfil.functions.forEach(function (funcion) {
                if (funcion.Eliminada !== undefined || funcion.Agregada !== undefined) {
                    funcTocados.push(funcion);
                }

                if (funcion.Eliminada == undefined && funcion.Agregada == undefined) {
                    funcSintocar.push(funcion.Descripcion);
                }

            });

            funcTocados.forEach(function (item) {

                if (item.Agregada) {
                    funcionActual.push(item.Descripcion);
                } else {
                    funcionAnterior.push(item.Descripcion);
                }

            });

            funcSintocar.forEach(function (x) {

                funcionActual.push(x);
                funcionAnterior.push(x);
            });

            if (funcionAnterior.length > 0) {
                funcionAnterior.forEach(x => anterior += x.toString() + ', ');
            } else {
                anterior += "[Sin permisos]"
            }

            if (funcionActual.length > 0) {
                funcionActual.forEach(x => actual += x.toString() + ', ');
            } else {
                actual += '[Sin permisos]'
            }

        });
    });

    let action = actual + ' % ' + anterior;
    LogsProxy.SaveOperationLog('SEGURIDAD,MODIFICACION,PERFIL', action, null, null, null, null, null, "SEGURIDAD");

    _setRedirect();


}